import UserMenu from "../../../auth/UserMenu";
import "../../../../styles/adminPageHeader.css";

export default function AdminPageHeader({
  eyebrow = "Administration",
  title,
  description,
  onClose,
  navigation = null,
  primaryActions = null,
  maintenanceActions = null,
}) {
  return (
    <header className="admin-page-header">
      <div className="admin-page-header__row">
        <div className="admin-page-header__intro">
          {eyebrow ? <p className="admin-page-header__eyebrow">{eyebrow}</p> : null}
          <h1 className="admin-page-header__title">{title}</h1>
        </div>

        <div className="admin-page-header__actions">
          {maintenanceActions ? (
            <div className="admin-page-header__action-group">{maintenanceActions}</div>
          ) : null}
          {primaryActions ? (
            <div className="admin-page-header__action-group">{primaryActions}</div>
          ) : null}
          {onClose ? (
            <button type="button" className="admin-page-header__back" onClick={onClose}>
              Back to map
            </button>
          ) : null}
          <UserMenu />
        </div>
      </div>

      {description ? <p className="admin-page-header__description">{description}</p> : null}

      {navigation ? <div className="admin-page-header__nav">{navigation}</div> : null}
    </header>
  );
}
